import { ChevronRight } from "lucide-react";
import { formatCurrency } from "@veorest/utils";
import type { AnalyticsByClientRow } from "../../lib/partnerReports";
import { useI18n } from "../../i18n";

interface ClientBreakdownTableProps {
  rows: AnalyticsByClientRow[];
  loading: boolean;
  onOpen: (tenantId: string) => void;
}

export function ClientBreakdownTable({ rows, loading, onOpen }: ClientBreakdownTableProps) {
  const { t, locale } = useI18n();

  return (
    <div className="report-table-wrap">
      <table className="table-flat">
        <thead>
          <tr>
            <th>{t("analytics.colClient")}</th>
            <th className="text-end">{t("analytics.colOrders")}</th>
            <th className="text-end">{t("analytics.colCompleted")}</th>
            <th className="text-end">{t("analytics.colCancelled")}</th>
            <th className="text-end">{t("analytics.colDeliveryFees")}</th>
            <th className="text-end">{t("analytics.colCharges")}</th>
            <th className="text-end">{t("analytics.colOutstanding")}</th>
            <th className="w-10" />
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={8} className="py-10 text-center text-sm text-[var(--text-muted)]">
                {t("common.loading")}
              </td>
            </tr>
          ) : rows.length === 0 ? (
            <tr>
              <td colSpan={8} className="py-10 text-center text-sm text-[var(--text-muted)]">
                {t("analytics.empty")}
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr
                key={row.tenant_id}
                onClick={() => onOpen(row.tenant_id)}
                className="cursor-pointer"
              >
                <td className="font-semibold text-[var(--text-primary)]">{row.name}</td>
                <td className="text-end tabular">{row.orders}</td>
                <td className="text-end tabular">{row.completed}</td>
                <td className="text-end tabular">{row.cancelled}</td>
                <td className="text-end tabular">
                  {row.delivery_fees > 0
                    ? formatCurrency(row.delivery_fees, row.currency, locale)
                    : "—"}
                </td>
                <td className="text-end tabular">
                  {row.client_charges > 0
                    ? formatCurrency(row.client_charges, row.currency, locale)
                    : "—"}
                </td>
                <td className="text-end tabular">
                  {row.outstanding > 0 ? (
                    <span className="font-bold text-[var(--danger,#dc2626)]">
                      {formatCurrency(row.outstanding, row.currency, locale)}
                    </span>
                  ) : (
                    "—"
                  )}
                </td>
                <td className="text-end">
                  <ChevronRight className="inline h-4 w-4 text-[var(--text-muted)] rtl:rotate-180" />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
